<template>

    <div class="element nested-element last-element white" v-show="setExpanded">
        <div class="element-heading">
            <div class="element-name">
                {{ game.display_name }}
                <small :title="game.output_identification_name + ' (' + game.input_identification_name + ')'">{{ game.output_identification_name }} ({{ game.input_identification_name }})</small>
            </div>
            <div class="element-buttons">
                <a href="javascript:void(0);" class="text-primary edit" v-if="userHasPermission('marketing_resources.marketing_resources.edit')" @click="editGame" :title="t.__('Edytuj')"><i class="fa fa-pencil-square-o"></i></a>
                <a href="javascript:void(0);" class="text-dark translate" v-if="userHasPermission('marketing_resources.marketing_resources.edit')" @click="translateGame" :title="t.__('Tłumacz')"><i class="fa fa-language"></i></a>
                <a href="javascript:void(0);" class="text-info preview" @click="previewGame" :title="t.__('Podgląd')"><i class="fa fa-eye"></i></a>
            </div>
        </div>

    </div>

</template>

<script>
    export default {

        name: 'MarketingResourcesGame',

        props: [
            'game',
            'setExpanded'
        ],

        data() {
            return {
                eventHub: window.eventHub
            }
        },

        methods: {

            editGame() {
                this.eventHub.$emit('marketing-resources-edit', 'game', this.game);
            },

            translateGame() {
                this.eventHub.$emit('marketing-resources-translate', 'game', this.game);
            },

            previewGame() {
                this.eventHub.$emit('marketing-resources-preview', 'game', this.game);
            }

        },

    }
</script>

<style scoped>

</style>
